import { FormikContextType } from 'formik';
import { IQuestion } from 'types/Question.types';
import React from 'react';
import {
  AdditionalWrapper,
  AutoSetMessage,
  Container,
  ErrorContainer,
  ErrorMessage,
  PriceContainer,
  PriceLabel,
  PriceValue,
} from './FormItemWrapper.styled';
import { useTranslation } from 'react-i18next';
import { useFormatMoney } from 'utils/hooks/useFormatMoney';
import { useSelector } from 'react-redux';
import { IRootReducerState } from 'store/store';

interface IFormWrapperProps {
  question: IQuestion;
  context: FormikContextType<any>;
  isTouched: boolean;
  children: React.ReactNode;
  questionPrice: number | undefined;
  isInlineControl?: boolean;
  stacksWhenNarrow?: boolean;
}

const FormItemWrapper = ({
  question,
  context,
  isTouched,
  children,
  questionPrice,
  isInlineControl,
  stacksWhenNarrow,
}: IFormWrapperProps) => {
  const { t } = useTranslation();

  const { currency } = useSelector(
    (state: IRootReducerState) => state.shoppingCartInfo
  );

  const formatMoney = useFormatMoney(currency);
  const errorMessage = context.errors[question.initialKey];

  const isAddedPriceNegative =
    typeof questionPrice == 'number' && questionPrice < 0;

  return (
    <Container
      isInlineControl={isInlineControl}
      stacksWhenNarrow={stacksWhenNarrow}
    >
      {children}
      <AdditionalWrapper isInlineControl={isInlineControl}>
        {question.disabled && (
          <AutoSetMessage>
            {t('Automatically set based on your choices')}
          </AutoSetMessage>
        )}
        {isTouched && errorMessage && (
          <ErrorContainer>
            <ErrorMessage>{errorMessage}</ErrorMessage>
          </ErrorContainer>
        )}
        {questionPrice !== undefined && (
          <PriceContainer>
            <PriceLabel>
              {isAddedPriceNegative ? t('Discount') : t('Added price')}:
            </PriceLabel>
            <PriceValue>{formatMoney(questionPrice)}</PriceValue>
          </PriceContainer>
        )}
      </AdditionalWrapper>
    </Container>
  );
};

export default FormItemWrapper;
